import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from '#src/atoms/layout/FullWidthContainer/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { HeadlineS } from '#src/atoms/typography/index.tsx';

import type { Props as CompetitionProps } from './Competition/index.tsx';
import { Competition } from './Competition/index.tsx';

type Props = {
  competitions: CompetitionProps['competition'][];
};

export const Competitions = ({ competitions }: Props) => {
  return (
    <FullWidthContainer>
      <Vertical gap={1.5}>
        <HeadlineS as="h2">
          <FormattedMessage
            id="Seo.Team.Competitions.competingIn"
            defaultMessage="Competing In"
          />
        </HeadlineS>
        {competitions.map(competition => (
          <Competition key={competition.slug} competition={competition} />
        ))}
      </Vertical>
    </FullWidthContainer>
  );
};
